export const strings = {
  workInProgressTitle: 'Work in Progress',
  workInProgressBodyLine1: 'Switching to Admin mode now may cause you to lose any work performed on this page.',
  workInProgressBodyLine2: 'Do you wish to continue?',
};
